var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPDATE_EARLY_COD_CHARGES_REQUEST, updateEarlyCodChargesFailure, updateEarlyCodChargesSuccess, } from "../../actions";
import APIIN from "../../../utils/APIIN";
const onUpdateEarlyCODCharges = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.post(`rms/admin/early/cod?tenantId=${action.payload.tenantId}&countryCode=${action.payload.countryCode}`, action.payload.earlyCODCharges)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* updateEarlyCODChargesWorker(action) {
    try {
        const data = yield call(onUpdateEarlyCODCharges, action);
        yield put(updateEarlyCodChargesSuccess(data));
    }
    catch (error) {
        yield put(updateEarlyCodChargesFailure(error));
    }
}
export function* watchUpdateEarlyCODCharges() {
    yield takeLatest(UPDATE_EARLY_COD_CHARGES_REQUEST, updateEarlyCODChargesWorker);
}
